export const metaDescriptionContent = {
  content: '삼성 임직원 전용 쇼핑몰, 웰스토리몰 다양한 임직원 혜택과 상품을 만나보세요.',
  boContent: '삼성 웰스토리몰 관리자(ADMIN)를 위한 전용 서비스입니다.',
  poContent: '삼성 웰스토리몰 공급업체를 위한 전용 서비스입니다.',
  coContent: '삼성 웰스토리몰 클라이언트를 위한 전용 서비스입니다.',
};
export const documentTitle = {
  title: '웰스토리몰 - 건강함에 새로움을 더하다.',
  boTitle: '웰스토리몰 관리자 ADMIN',
  poTitle: '웰스토리몰 파트너 ADMIN',
  coTitle: '웰스토리몰 클라이언트 ADMIN',
};
